module.exports = __webpack_public_path__ + "media/images/icons/list-4e5416a69489eeffdda97ee0cf974024.svg";